import type { WorkItemDto } from '@customTypes/types';
import { Flex, Space, Stack, Text } from '@mantine/core';
import { FormattedDate } from 'react-intl';

import { translate } from '@/shared/i18n/translate';
import { LBButton } from '@/shared/ui-kit/components';

export const ManageCurrentContractView = ({
  workItem,
  requestEndDate,
  acceptNewEndDate
}: {
  workItem: WorkItemDto;
  requestEndDate: () => void;
  acceptNewEndDate: () => void;
}) => (
  <>
    {workItem.newEndDate && (
      <Stack gap={10}>
        <Text fz={14}>
          {translate(
            'popups.artistWorkInteraction.manageCurentContract.clubSetLastWorkDate'
          )}
        </Text>
        <Flex align='center' gap={10}>
          <Text fz={14}>{translate('commons.lastWorkDay')}: </Text>
          <Text fw={700} fz={14}>
            <FormattedDate value={workItem.newEndDate} />
          </Text>
        </Flex>
        {workItem.newEndDate &&
          !workItem.artistRequestedEndDate &&
          !workItem.approvedByArtist && (
            <LBButton fullWidth onClick={acceptNewEndDate}>
              {translate('commons.iConfirm')}
            </LBButton>
          )}
      </Stack>
    )}

    {!workItem.newEndDate &&
      !workItem.artistRequestedEndDate &&
      workItem.arrivalConfirmed && (
        <>
          <Text fz={14}>
            {translate(
              'popups.artistWorkInteraction.manageCurentContract.weCanRequestLastWorkDate'
            )}
          </Text>
          <LBButton fullWidth onClick={requestEndDate}>
            {translate('commons.request')}
          </LBButton>
        </>
      )}

    {!workItem.newEndDate &&
      workItem.artistRequestedEndDate &&
      workItem.arrivalConfirmed && (
        <Text fz={14}>
          {translate(
            'popups.artistWorkInteraction.manageCurentContract.pendingLastWorkDateRequest'
          )}
        </Text>
      )}

    {!workItem.newEndDate && !workItem.arrivalConfirmed && (
      <>
        <Text fz={14}>
          {translate(
            'popups.artistWorkInteraction.manageCurentContract.workStartOnArtistArrivalConfirm'
          )}
        </Text>
        <Space h={24} />
      </>
    )}
  </>
);
